import React from "react";

const Shorts = () => {
  const shorts = [
    "c1tvo5N4sw0",
    "S_WRyGBX5-0",
    "AK-VpvDmJzM",
    "biAvTjOb1FM",
    "Y6rY7Um76sg",
  ];

  return (
    <div className="py-8 5xl:py-12 7xl:py-16 10xl:py-20 11xl:py-24">
      <h1 className="text-center text-xl 5xl:text-2xl 7xl:text-3xl 10xl:text-4xl 11xl:text-6xl font-bold mb-6 6xl:mb-9 9xl:mb-14 10xl:mb-20 11xl:mb-24">
        Style That Speaks, Sarees That Shine
      </h1>

      <div className="flex gap-4 overflow-x-auto scrollbar-hide">
        {shorts.map((videoId, index) => (
          <div key={index} className="flex-shrink-0">
            <iframe
              className="w-[300px] h-[400px] sm:w-[360px] sm:h-[420px] md:w-[320px] md:h-[350px] 9xl:w-[400px] 9xl:h-[460px] 10xl:w-[540px] 10xl:h-[590px] 11xl:w-[770px] 11xl:h-[790px] rounded-lg"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=0&mute=1&playsinline=1`}
              title={`YouTube Short ${index + 1}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
              allowFullScreen
            ></iframe>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Shorts;
